/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_BenefitsInputs */

const en_dialog_premium_benefits = /** @type {(inputs: Dialog_Premium_BenefitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and get all these benefits`)
};

const es_dialog_premium_benefits = /** @type {(inputs: Dialog_Premium_BenefitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`y obtén todos estos beneficios`)
};

/**
* | output |
* | --- |
* | "and get all these benefits" |
*
* @param {Dialog_Premium_BenefitsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_benefits = /** @type {((inputs?: Dialog_Premium_BenefitsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_BenefitsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_benefits(inputs)
	return en_dialog_premium_benefits(inputs)
});